import React from 'react'

import axios from 'axios'
import { baseUrl } from '../../config/clientsConfig'

const AmenitiesService = {
 
    getAmentities: async () => {
        return axios.get(`${baseUrl}/amenities`)
    },
    createAmenities: async (data) => {
        return axios.post(`${baseUrl}/amenity`, data)
    },
    updateAmenities: async (data) => {
        return axios.put(`${baseUrl}/amenity`, data)
    },
    getAmenitiesByType: async (type) =>{
        return axios.get(`${baseUrl}/amenitiesByType?type=${type}`)
    }

}

export default AmenitiesService